import React from 'react';

const CardInfo = ({ title, icon, value, percent, subtitle }) => {
    return (
        <div className='m15 dash-color'>
            <div className='dash-col p-10 mrml10'>
                <div className="card-row">
                    <div>
                        <div className="card-info-title">
                            {title}
                        </div>
                        <div className="card-info-value pt-10">
                            {value}
                        </div>
                    </div>
                    <div>
                        <div className='dash-icon'>
                            <i className={`dx-icon-${icon} fs20`}></i>
                        </div>
                    </div>
                </div>
                <div className="pt-10">
                    <div className='dash-footer'>
                        <span className='dash-percent'>{percent}</span>
                        <span className='dash-dateinfo'>{subtitle}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardInfo;
